var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtploader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 176,
    viewBox: "0 0 211 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M148.902 103.749L149.09 103.373L173.157 63.0674H98.332L86.3951 48.1438L181.929 48.3227L210.664 0L0 0.5606L106.354 175.39L134.906 127.067L122.404 103.749H148.902Z",
    fill: "#042b62",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtploader);
export default __webpack_public_path__ + "static/media/Otploader.9f4831c0aaed7fb3a5a5f0f6bfc6b532.svg";
export { ForwardRef as ReactComponent };